import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Grid, Row, Col, Carousel, Glyphicon, Button, Table } from 'react-bootstrap';
import Query from 'query-string';
import SiteLoader from '../layout/site-loader';
import Filters from './filters/filters';
import Card from './card';
import {
  basketUpdate,
  basketUpdateLineItem,
  getNewOrders,
  downloadStockSheet,
  updateDeliveryAddress,
  getNewFeaturedProducts,
  emptyRepairBasket
} from '../../actions/orders';
import ArrowButton from '../common/button-arrow';
import { toast } from "react-toastify";
import ToastMessage from "../common/toast-message";
import { getPromotionalBannersForNewOrderPage } from '../../actions/promotional_banners';
import { getOutlets } from '../../actions/outlet';
import Select from "../common/form/elements/select";
import { getStockNotifications } from '../../actions/stock-notifications';
import NewFeaturedProductCard from "./new-featured-product-card";
import NewOrderTabs from './new-order-tabs';
import ConfirmPopup from '../common/confirm-popup';
import { history } from '../../store';
import NewCustomerNumberBanner from '../new-customer-number/new-customer-number-banner';

import './styles.css';

const tab = {
  tobacco: 'tobacco',
  blu: 'blu',
  zone: 'zone'
}

class NewOrder extends Component {
  constructor(props) {
    super(props);

    const { location: { hash } } = props;
    const selectedTab = hash ? hash.replace('#', '') : tab.blu;

    this.state = {
      confirmProduct: {},
      product_qty: 0,
      products_filtered: {},
      categories_ids: [],
      product_search: '',
      filtering_cat: false,
      filtering_string: false,
      fetching_products: true,
      loadingRepairReview: false,
      isOrderMoreModalClosed: false,
      selectedTab
    };

    history.push(`#${selectedTab}`);
    history.listen((location) => {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.hash,
        title: "Order Now"
      });
    });
  }

  componentDidMount() {
    const { dispatch, stockNotificationsEnabled, newOrderingEnabled, deliveryAddress } = this.props;

    dispatch(emptyRepairBasket());
    dispatch(getOutlets(false, false));
    dispatch(getNewOrders()).then(() => {
      dispatch(getPromotionalBannersForNewOrderPage);

      if (newOrderingEnabled && !!deliveryAddress) {
        dispatch(getNewFeaturedProducts(deliveryAddress.id));
      }

      if (window.location.search) {
        if (Query.parse(window.location.search).categoryIds || Query.parse(window.location.search).searchQuery) {
          let categoryIds = Query.parse(window.location.search).categoryIds
          categoryIds = (categoryIds && categoryIds.split(',').map(id => parseInt(id))) || [];
          const searchQuery = Query.parse(window.location.search).searchQuery;

          this.setState({
            categories_ids: categoryIds,
            product_search: searchQuery,
            filtering_string: !!searchQuery.length,
            filtering_cat: !!categoryIds.length
          });

          this.filterCategories(categoryIds);
        }
      }
    }).then(() => {
      this.setState({
        fetching_products: false
      })
    });

    if (stockNotificationsEnabled) {
      dispatch(getStockNotifications());
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, newOrderingEnabled, deliveryAddress } = this.props;

    if (newOrderingEnabled && prevProps.deliveryAddress !== deliveryAddress) {
      if (!!deliveryAddress) {
        dispatch(getNewFeaturedProducts(deliveryAddress.id));
      }
    }

    if (this.props.repairedProduct !== prevProps.repairedProduct) {
      if (this.props.repairedProduct) {
        this.renderRepairProduct()
      } else {
        if (document.getElementById('repair-product-node')) {
          this.killRepairBox();
        }
      }
    }

  }

  renderRepairProduct = () => {
    this.setState({
      repaired_product_quantity: this.props.repairedProduct.quantityIncrease
    })
    // fine the correct product
    let el = document.querySelector(`[data-id='${this.props.repairedProduct.id}']`);
    // take a variable of the parentNode which is effectively <div className='class-list' />
    // it might be easier to just call this with an id selector
    let parent = el.parentNode;
    // find the top  of the product for comparison against the products after
    let productTop = el.getBoundingClientRect().top;
    // store the scrollTop of the page to ensure there is no issues with slow loading/user scrolling
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // take the index of the current product within the class-list element
    let index = Array.prototype.indexOf.call(parent.children, el);
    // store the current product for use within the loop without changing the original product element
    let loopProduct = el;
    let itemY;
    // loop through the class-list product elements starting at the current product div
    for (let i = index; i <= parent.children.length; i++) {
      // update loop_product to the current product
      loopProduct = parent.children[i];
      // return the top of the current product being checked
      itemY = loopProduct.getBoundingClientRect().top;

      const newChildNode = document.createElement('DIV');
      newChildNode.id = 'repair-product-node';
      newChildNode.style.width = '100%';
      newChildNode.style.padding = '0 4px';
      // compare the top of the current product with the original product
      // if the current product top does not match the original product top
      // then we can assume we are on the next row
      // and as a result insert the repair box before this current element by creating a new div
      // and then using the reactDom render to render withn the new node
      if (itemY + scrollTop != productTop + scrollTop && !document.getElementById('repair-product-node')) {
        parent.insertBefore(newChildNode, parent.children[i])
        ReactDOM.render(this.renderRepairBox(), newChildNode);
        i = parent.children.length;
      }

      // if we have reached the end of the parent elements and there are no more products to loop through
      // then we simply place the repair box after the last element so that it appears on a row of its own after all elements
      if (i == parent.children.length - 1 && !document.getElementById('repair-product-node')) {
        parent.appendChild(newChildNode)
        ReactDOM.render(this.renderRepairBox(), newChildNode);
        i = parent.children.length;
      }
    }
  }

  renderRepairBox = () => {
    let product = this.props.products[this.props.repairedProduct.id];

    return (
      <div className="rep-repairs-box" id='repair-product-box'>
        <div className="rep-important-header">
          <div className="rep-important-icon-container"><span>!</span></div>
          <p>IMPORTANT: You have items in your order that you need to review.</p>
        </div>
        <p className="rep-main-text">
          We can see this product has been repaired by your John Player Representative during their last two visits to your store. To ensure you have enough stock to meet consumer demand, we recommend you increase the quantity you are ordering by the amount of outers shown below. Add the additional quantity by clicking the button "Add Additional Outers". <b>If you do not wish to do so, please select "0" in the quantity picker below</b>
        </p>
        <div className="rep-product-container">
          <div className="rep-product-repaired-container">
            <div className="rep-product-repaired-image">
              <img src={product.attributes.image} alt={product.attributes.name} />
            </div>
            <div className="rep-product-info-container">
              <p className="header-highlight">This product has been repaired</p>
              <p>{product.attributes.name}</p>
            </div>
          </div>
          <div className="rep-product-quantity-container">
            <input type="number" className="quantity-input" defaultValue={this.props.repairedProduct.quantityIncrease} value={this.state.repaired_product_quantity} onChange={e => this.updateRepairProductQuantity(e)} min={0} />
          </div>
        </div>
        <div className="rep-button-container">
          <ArrowButton color="green" submit={false} arrow={false} onClick={() => this.handleSubmitRepair()}>Add Additional Outers</ArrowButton>
        </div>
      </div>
    );
  }

  updateRepairProductQuantity = e => {
    this.setState({
      repaired_product_quantity: e.target.value
    });
  }

  handleSubmitRepair = () => {
    let newQuantity = Number(this.props.repairedProduct.originalQuantity) + Number(this.state.repaired_product_quantity);

    this.props.dispatch(basketUpdate({ id: this.props.repairedProduct.id, attributes: { "minimum-order-quantity": this.props.repairedProduct.originalQuantity } }, newQuantity, { confirm: false }));
    this.setState({
      repaired_product_quantity: null
    });
  }

  killRepairBox = () => {
    this.props.dispatch(emptyRepairBasket());
    document.getElementById('repair-product-node').parentElement.removeChild(document.getElementById('repair-product-node'));
    this.setState({
      repaired_product_quantity: null
    });
  }

  handleConfirmation = (product, qty, fromConfirm = false, updateQuantity = false) => {
    if (document.getElementById('repair-product-node')) {
      this.killRepairBox();
    }

    const { deliveryAddress, newOrderingEnabled } = this.props

    if (qty < 1) {
      toast.error(<ToastMessage iconStyle="error"
        message="Please select a quantity" />);
      return Promise.resolve();
    } else {
      if (fromConfirm) {
        return this.props.dispatch(basketUpdateLineItem(this.props.basket.line_items[product.id], qty, fromConfirm));
      } else {
        if (newOrderingEnabled) {
          return this.props.dispatch(
            basketUpdate(
              product,
              qty,
              {
                confirm: false,
                updateQuantity,
                deliveryAddressId: deliveryAddress && deliveryAddress.id,
                repairQuantity: !updateQuantity
              }
            )
          );
        } else {
          return this.props.dispatch(
            basketUpdate(product, qty, { confirm: false, updateQuantity })
          );
        }
      }
    }
  };

  handleDeliveryAddressChange(storeId) {
    const { dispatch } = this.props;

    dispatch(updateDeliveryAddress(storeId));
    dispatch(getNewFeaturedProducts(storeId));
  }

  basketContainsItems() {
    return (Object.keys(this.props.basket.line_items).length > 0);
  }

  getSelectedStoreId() {
    const { defaultOutletId, deliveryAddress } = this.props;

    return deliveryAddress ? deliveryAddress.id : defaultOutletId;
  }

  renderDeliveryAddressSelector() {
    const { stores } = this.props;
    const selectedStoreId = this.getSelectedStoreId();
    const orderingStores = stores.filter(store => store.attributes.ordering);
    let selectorValues = orderingStores.map((store) => {
      return {
        value: store['id'],
        label: `${store.attributes.name} ${store.attributes['customer-number']}`
      }
    });

    return (
      <div className="order-now-container">
        <p>Please ensure you select the correct store as a delivery address for this order. Once you add products to your basket and then wish to change your delivery address this will automatically start a new order.</p>
        <Select
          disabled={this.basketContainsItems()}
          onChange={(value) => this.handleDeliveryAddressChange(value)}
          model='deep.delivery_store'
          values={selectorValues}
          selectedValue={selectedStoreId.toString()} />
      </div>
    );
  }

  getGameBanner() {
    const { gameBanners } = this.props;
    const selectedStoreId = this.getSelectedStoreId();
    const gameBannerByOutlet = gameBanners.find(banner => banner['outlet-id'] === selectedStoreId);

    return gameBannerByOutlet ? gameBannerByOutlet['banner'] : null;
  }

  renderBanner() {
    const { promotionalBanners } = this.props;
    const { selectedTab } = this.state;
    let categoryNames = [];

    switch (selectedTab) {
      case tab.blu:
        categoryNames.push('Vape');
        break;
      case tab.zone:
        categoryNames.push('Oral Tobacco');
        break;
      case tab.tobacco:
        categoryNames = ['Cigarettes', 'Cigars', 'Rolling Papers & Accessories', 'Tobacco', 'Flavour cards'];
        break;
    }

    const banners = promotionalBanners.promotional_banners.filter((promotionalBanner) => categoryNames.includes(promotionalBanner.attributes['category-name']));
    const showCarouselControls = banners.length > 1;

    return (
      <Carousel controls={showCarouselControls} indicators={showCarouselControls}>
        {banners.map((promotionalBanner, key) => (
          <Carousel.Item key={key}>
            <div className="imgPreview">
              {promotionalBanner.attributes['image-uid'].endsWith('.mp4') ? (
                <video loop autoPlay className="banner-video" key={`video-${promotionalBanner.id}`} id={`video-id-${promotionalBanner.id}`}>
                  <source src={promotionalBanner.attributes.links.image} type="video/mp4" key={`source-${promotionalBanner.id}`} id={`source-id-${promotionalBanner.id}`}>
                  </source>
                  Sorry, your browser doesn't support videos.
                </video>
              ) : (
                <img src={promotionalBanner.attributes.links.image} />
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }

  renderProductCard(product, missingProductIdList, gameProductIdsList) {
    const { selectedTab } = this.state;
    const isTobacco = selectedTab === tab.tobacco;

    return (
      <Col key={'product$' + product.id} data-id={product.id} xs={12} sm={6} md={4} lg={4} className="product-row">
        <div className="card-border">
          <Card
            new_order_page={true}
            missingFromAudit={missingProductIdList.includes(Number(product.id))}
            game={gameProductIdsList.includes(Number(product.id))}
            product={product}
            isTobacco={isTobacco}
            handleAddReplacement={this.handleAddReplacement}
            handleConfirmation={this.handleConfirmation}
          />
        </div>
      </Col>
    );
  }

  renderGameLevel(gameLevel) {
    return (
      <Col key={'level-' + gameLevel.level} lg={3}>
        Level {gameLevel.level}:
        <br/>place single order for <b>{gameLevel['minimum-number-of-outers']} outers</b> - chance to <b>win €{gameLevel['prize-amount']}</b>
      </Col>
    );
  }

  filterProductsByCategory = (products) =>
    products.filter((product) => {
      const { selectedTab } = this.state;
      const { attributes: { category } } = product;

      if (selectedTab === tab.tobacco) {
        return !['Vape', 'Oral Tobacco'].includes(category);
      } else if (selectedTab === tab.blu) {
        return category === 'Vape';
      } else if (selectedTab === tab.zone) {
        return category === 'Oral Tobacco';
      }
    });

  sortProducts = (orderedProducts, missingProductIdList, gameProductIdsList) =>
    this.filterProductsByCategory(orderedProducts)
      .sort((a, b) => a.__index - b.__index)
      .map((product) => this.renderProductCard(product, missingProductIdList, gameProductIdsList));

  renderProductCards(products, missingProductIdList, gameProductIdsList) {
    const { filtering_string, filtering_cat } = this.state;

    if (filtering_string || filtering_cat) {
      const { products_filtered } = this.state;
      const orderedProducts = Object.keys(products_filtered).map((curr) => products_filtered[curr]);

      return this.sortProducts(orderedProducts, missingProductIdList, gameProductIdsList);
    } else {
      const orderedProducts = Object.keys(products).map((curr) => products[curr]);

      return this.sortProducts(orderedProducts, missingProductIdList, gameProductIdsList);
    }
  }

  downloadCSV = () => {
    this.props.dispatch(downloadStockSheet());
  };

  handleProductSearch = e => {
    if (document.getElementById('repair-product-node')) {
      this.killRepairBox();
    }

    if (e.target.value.length > 0) {
      this.setState({
        filtering_string: true,
        product_search: e.target.value
      }, () => {
        if (this.state.product_search.length > 0) {
          this.filterString(this.state.product_search);
        } else {
          this.setState({
            products_filtered: {}
          })
        }
      })
    } else {
      this.setState({
        filtering_string: false,
        product_search: '',
      }, () => {
        if (this.state.categories_ids.length > 0) {
          this.filterCategories(this.state.categories_ids);
        } else {
          this.setState({
            products_filtered: {}
          })
        }
      })
    }
  }

  handleTabSelect = (selectedTab) => {
    this.setState({ selectedTab }, () => {
      history.push(`#${selectedTab}`);
    });
  }

  filterString = filter => {
    const { products } = this.props;
    let products_filtered;

    filter = filter.toLowerCase();
    products_filtered = Object.keys(products).map(product => {
      const { selectedTab } = this.state;
      let brand = products[product].attributes.brand.toLowerCase();
      let category = products[product].attributes.category.toLowerCase();
      let name = products[product].attributes.name.toLowerCase();

      if (selectedTab === tab.blu) {
        if ((brand.includes(filter) || name.includes(filter)) && category === 'Vape') {
          return products[product];
        };
      } else if (this.state.categories_ids.length > 0) {
        if ((brand.includes(filter) || category.includes(filter) || name.includes(filter)) && this.state.categories_ids.includes(products[product].attributes.category_id)) {
          return products[product];
        };
      } else {
        if (brand.includes(filter) || category.includes(filter) || name.includes(filter)) {
          return products[product];
        };
      }
    });

    this.filterProducts(products_filtered);
  }

  filterCategories = (categories_ids) => {
    if (document.getElementById('repair-product-node')) {
      this.killRepairBox();
    }

    if (categories_ids.length > 0) {
      this.setState({
        filtering_cat: true,
        categories_ids: categories_ids
      }, () => {
        const { products } = this.props;
        let products_filtered = Object.keys(products).map(product => {
          if (this.state.product_search.length > 0) {
            let brand = products[product].attributes.brand.toLowerCase();
            let category = products[product].attributes.category.toLowerCase();
            let name = products[product].attributes.name.toLowerCase();

            if ((brand.includes(this.state.product_search) || category.includes(this.state.product_search) || name.includes(this.state.product_search)) && categories_ids.includes(products[product].attributes.category_id)) {
              return products[product];
            };
          } else {
            if (categories_ids.includes(products[product].attributes.category_id)) {
              return products[product];
            };
          }
        });
        this.filterProducts(products_filtered);
      })
    } else {
      this.setState({
        filtering_cat: false,
        categories_ids: [],
      }, () => {
        if (this.state.product_search.length > 0) {
          this.filterString(this.state.product_search);
        } else {
          this.setState({
            products_filtered: {}
          })
        }
      })
    }
  }

  filterProducts = (products_filtered) => {
    products_filtered = products_filtered.filter(product => product !== undefined);
    products_filtered = products_filtered.reduce((result, item) => {
      result[item.id] = item;

      return result;
    }, {});

    this.setState({
      fetching_products: false,
      products_filtered: products_filtered
    });
  }

  ProductIdsList(stores, ProductIds, type) {
    if (stores.length > 0) {
      const selectedStore = this.selectStore();

      if (selectedStore) {
        if (type === 'missing') {
          return selectedStore.attributes['missing-stock-it-product-ids-from-audit'];
        } else if (type === 'game') {
          return selectedStore.attributes['active-game'] ? selectedStore.attributes['active-game']['active-game-product-ids'] : [];
        }
      }
    }
    if (ProductIds && ProductIds.length > 0) {
      return ProductIds;
    }

    return [];
  }

  GameLevelsList(stores, gameLevels) {
    if (stores.length > 0) {
      const selectedStore = this.selectStore();

      if (selectedStore) {
        return selectedStore.attributes['active-game'] ? selectedStore.attributes['active-game']['game-levels'] : [];
      }

      return stores.find(store => store.attributes['active-game'] !== undefined);
    }

    if (gameLevels.length > 0) {
      return gameLevels;
    }

    return [];
  }

  HasNoGameLevelsValue(stores, hasNoLevels) {
    if (stores.length > 0) {
      const selectedStore = this.selectStore();

      if (selectedStore) {
        return selectedStore.attributes['active-game'] ? selectedStore.attributes['active-game']['has-no-levels'] : false;
      }

      return stores.find(store => store.attributes['active-game'] !== undefined);
    }

    if (hasNoLevels !== undefined) {
      return hasNoLevels;
    }
  }

  selectStore = () => {
    const { stores } = this.props;
    const selectedStoreId = this.getSelectedStoreId();

    return stores.find(store => +store.id === selectedStoreId);
  }

  showBanner = () => {
    const { stores, gameProductIds, products } = this.props;
    const gameProductIdsList = this.ProductIdsList(stores, gameProductIds, 'game');
    let filteredProductList = Object.values(products).filter(
      (product) => gameProductIdsList.includes(+product.id)
    );

    if (gameProductIdsList.length === 0 || filteredProductList.length !== gameProductIdsList.length) {
      return false;
    }

    filteredProductList = Object.values(filteredProductList).filter(
      (product) => product.attributes.stock_status !== 'In Stock'
    );

    if (filteredProductList.length !== 0) {
      return false;
    }

    return true;
  };

  addProductsToBasket = (productIds, qty = 1) => {
    const { dispatch, basket, products } = this.props;

    const newProducts = Object.values(products).filter(
      (product) => productIds.includes(+product.id) && product.attributes.stock_status === "In Stock" && product.attributes.status === "ACTIVE"
    );

    newProducts.forEach((product) => {
      if (!!!Object.values(basket.line_items).find((lineItem) => lineItem.product.name === product.attributes.name)) {
        dispatch(basketUpdate(product, qty, { confirm: false }));
      }
    });
  }

  handleBannerButtonOnClick = () => {
    const { stores, gameProductIds } = this.props;
    const productIds = this.ProductIdsList(stores, gameProductIds, 'game');
    const selectedStore = this.selectStore();

    if (selectedStore) {
      const activeNoLevelGame = selectedStore.attributes['active-game']

      this.addProductsToBasket(productIds, activeNoLevelGame ? activeNoLevelGame['no-level-quantity'] : undefined);
    } else {
      const { activeGame } = this.props;

      this.addProductsToBasket(productIds, activeGame ? activeGame['no-level-quantity'] : undefined);
    }
  };

  handleOrderMoreModalClose = (isConfirm) => {
    const { orderMoreProducts } = this.props;

    this.setState({ isOrderMoreModalClosed: true }, () => {
      if (isConfirm) {
        const productIds = orderMoreProducts.map((product) => product['product-id']);
        this.addProductsToBasket(productIds);
      }
    });
  };

  hasVapeProducts = () => {
    const { products } = this.props;
    const productValues = Object.values(products);

    for (let i = 0; i < Object.values(productValues).length; i++) {
      if (productValues[i].attributes.category === 'Vape' && productValues[i].attributes.status === 'ACTIVE') {
        return true;
      }
    }

    return false;
  }

  render() {
    if (!!this.state.fetching_products) {
      return <SiteLoader />;
    }

    const { projectUnifyEnabled, stores, missingProductIds, gameProductIds, gameLevels, products, hasNoLevels, orderMoreName,
      orderMoreProducts } = this.props;
    const { product_search, selectedTab, categories_ids, isOrderMoreModalClosed } = this.state;
    const missingProductIdsList = this.ProductIdsList(stores, missingProductIds, 'missing');
    const gameProductIdsList = this.ProductIdsList(stores, gameProductIds, 'game');
    const gameLevelsList = this.GameLevelsList(stores, gameLevels);
    const hasNoLevelsValue = this.HasNoGameLevelsValue(stores, hasNoLevels);
    const buttonColor = selectedTab === tab.tobacco ? "grey" : 'white';
    const showGameBanner = !projectUnifyEnabled && (gameLevelsList.length > 0 || hasNoLevelsValue) && this.showBanner();
    const isBluTabActive = this.hasVapeProducts();

    return (
      <Grid bsClass="container" fluid className={"new-order"}>
        { projectUnifyEnabled && <Row>
          <NewCustomerNumberBanner />
        </Row> }
        { !projectUnifyEnabled && !showGameBanner && <Row>
          {this.props.promotionalBanners.promotional_banners && this.renderBanner()}
        </Row> }
        { showGameBanner && <Row>
          <Col lg={12} className="game-banner">
            <div
              className="imgPreview"
              onClick={hasNoLevelsValue ? this.handleBannerButtonOnClick : () => {}}
            >
              <img src={this.getGameBanner()} className={hasNoLevelsValue ? "pointer" : ""} />
            </div>
          </Col>
        </Row> }
        <Grid>
          <Row>
            <Col lg={12}>
              <NewOrderTabs
                selectedTab={selectedTab}
                tab={tab}
                onTabSelect={this.handleTabSelect}
                isBluTabActive={isBluTabActive}
              />
            </Col>
          </Row>
          <h1>Order Now</h1>
          {this.props.newOrderingEnabled &&
            <Row>
              <Col lg={12}>
                {this.props.defaultOutletId && this.renderDeliveryAddressSelector()}
              </Col>
            </Row>
          }
          <Row>
            <Col className="search-wrapper">
              <div className="search-container">
                <input
                  type='text'
                  name='product_search'
                  value={product_search}
                  onChange={(e) => this.handleProductSearch(e)}
                  placeholder='Search by product category, product brand or product name'
                />
                <Glyphicon glyph={'search'} />
              </div>
              <ArrowButton submit={false}
                color={buttonColor}
                arrow={false}
                className="pull-right"
                onClick={this.downloadCSV}>Download Stock Sheet</ArrowButton>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              {selectedTab === tab.tobacco ?
                <Filters filterCategories={this.filterCategories} preFilteredCategories={categories_ids} /> :
                <div className='order-tab-space'></div>}
            </Col>
          </Row>
          {this.props.possibleOrderLimit && (<div className="order-highlight">
            Your tobacco products order may be subject to a maximum outer quantity limit. If this limit is reached, you will be notified when confirming your order
          </div>)}
          <Row className="card-list" id='card-list'>
            {
              this.props.newOrderingEnabled &&
              this.props.newFeaturedProducts && (this.props.newFeaturedProducts.length > 0) &&
              <Col xs={12} sm={12} md={12} lg={8} className="product-row">
                <NewFeaturedProductCard products={this.props.newFeaturedProducts}
                  handleConfirmation={this.handleConfirmation}
                  new_order_page={true} />
              </Col>
            }
            {!this.state.fetching_products && this.renderProductCards(products, missingProductIdsList, gameProductIdsList)}
          </Row>
          <div className="new-order-button-links">
            <Link to={'/latest-news'}>
              <ArrowButton submit={false}
                color={buttonColor}
                arrow={false}
                className="pull-right">News</ArrowButton>
            </Link>
            <Link to={'/store-summary'}>
              <ArrowButton submit={false}
                color={buttonColor}
                arrow={false}
                className="pull-right">My Store Summary</ArrowButton>
            </Link>
            <Link to={'/contact-us'}>
              <ArrowButton submit={false}
                color={buttonColor}
                arrow={false}
                className="pull-right">Contact Us</ArrowButton>
            </Link>
          </div>
        </Grid>
        {orderMoreName && !isOrderMoreModalClosed &&
          <ConfirmPopup onClose={this.handleOrderMoreModalClose} confirmLabel="Add to basket">
            <p className="order-more">People usually also order {orderMoreName} with this product</p>
            <div className="more-products">
              {orderMoreProducts.map((product) => (
                <img className="more-product-image" src={product['product-image-uid']} />
              ))}
            </div>
          </ConfirmPopup>}
      </Grid>
    )
  }
}

const mapStateToProps = ({
  orders: {
    new: {
      products,
      basket,
      confirmedProduct: confirmed,
      hideConfirm,
      contentUrl,
      possibleOrderLimit,
      gameBanners,
      deliveryAddress,
      newFeaturedProducts,
      repairedProduct,
      orderMoreName,
      orderMoreProducts
    }
  },
  promotionalBanners,
  viewConfig: { editContent, profile },
  stores: { stores, missingProductIds, activeGame },
  features: {
    new_ordering: newOrderingEnabled,
    unify_project: projectUnifyEnabled,
    stock_notifications: stockNotificationsEnabled
  }
}) => ({
  products,
  newFeaturedProducts,
  basket,
  confirmed,
  hideConfirm,
  contentUrl,
  editContent,
  possibleOrderLimit,
  gameBanners,
  promotionalBanners: promotionalBanners,
  stores,
  missingProductIds,
  gameProductIds: activeGame ? activeGame['active-game-product-ids'] : [],
  gameLevels: activeGame ? activeGame['game-levels'] : [],
  hasNoLevels: activeGame ? activeGame['has-no-levels'] : false,
  activeGame: activeGame,
  deliveryAddress,
  newOrderingEnabled,
  stockNotificationsEnabled,
  projectUnifyEnabled,
  defaultOutletId: profile.attributes['default-outlet-id'],
  repairedProduct,
  orderMoreName,
  orderMoreProducts
});

export default connect(mapStateToProps)(NewOrder);



// WEBPACK FOOTER //
// ./src/components/new-order/index.jsx